import { useTranslation } from 'react-i18next';

import { SIGNUP_CARDS_FLAG } from 'constants/featureFlag';
import DepositBonusImg from 'styles/assets/images/deposit_bonus.png';
import SecurityImg from 'styles/assets/images/security.png';
import UnlockImg from 'styles/assets/images/unlock.png';

import styles from './styles.module.scss';

interface InfoList {
  id: string;
  header: string;
  description: string;
  imageSrc: string;
  imageClassName?: string;
  alt: string;
}

const SignUpInfoList = () => {
  const { t } = useTranslation();

  const INFO_LIST_INDIA: InfoList[] = [
    {
      id: 'tradeIndia',
      header: t('auth:signUpInfoBoxes.tradeIndia.header'),
      description: t('auth:signUpInfoBoxes.tradeIndia.description'),
      imageSrc: 'https://static.delta.exchange/web/home-page/signup-trade.svg',
      alt: 'Trade Now',
      imageClassName: styles.commonInrSignupImage,
    },
    {
      id: 'inrDeposits',
      header: t('auth:signUpInfoBoxes.inrDeposits.header'),
      description: t('auth:signUpInfoBoxes.inrDeposits.description'),
      imageSrc: 'https://static.delta.exchange/web/home-page/signup-bank.svg',
      imageClassName: styles.commonInrSignupImage,
      alt: 'INR Deposits',
    },
    {
      id: 'fullyCompliant',
      header: 'Fully Compliant',
      description: 'Registered with FIU-India & fully compliant with Indian regulations',
      imageSrc: 'https://static.delta.exchange/web/home-page/signup-offer.svg',
      imageClassName: styles.commonInrSignupImage,
      alt: 'Welcome Offer',
    },
  ];

  const INFO_BOX_LIST_GLOBAL: InfoList[] = [
    {
      id: 'depositBonus',
      header: t('auth:signUpInfoBoxes.depositBonus.header'),
      description: t('auth:signUpInfoBoxes.depositBonus.description'),
      imageSrc: DepositBonusImg,
      imageClassName: styles.depositImg,
      alt: 'Deposit Bonus',
    },
    {
      id: 'unlock',
      header: t('auth:signUpInfoBoxes.unlock.header'),
      description: t('auth:signUpInfoBoxes.unlock.description'),
      imageClassName: styles.unlockImg,
      imageSrc: UnlockImg,
      alt: 'Trade now',
    },
    {
      id: 'security',
      header: t('auth:signUpInfoBoxes.security.header'),
      description: t('auth:signUpInfoBoxes.security.description'),
      imageSrc: SecurityImg,
      imageClassName: styles.securityImg,
      alt: 'Secure',
    },
  ];

  const INFO_LIST: Record<typeof SIGNUP_CARDS_FLAG, InfoList[] | undefined> = {
    global: INFO_BOX_LIST_GLOBAL,
    india: INFO_LIST_INDIA,
  };

  return { INFO_LIST };
};

export { SignUpInfoList };
